import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  renderFormField,
  renderTextAreaField,
  formatPrice,
  normalizePrice,
} from "../../../utils/reduxField";
import * as _ from "lodash";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import {
  validateCreatePostForm,
  validatePrice,
  validateDiscount,
} from "../../../utils/formValidation";
import CreatorItem from "./creator-item/creator-item";
import { udpateLogPost } from "../../../utils/common";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert"; // Import
import localStore from "src/utils/local-storage";

class EditorTypeTab extends Component {
  constructor(props) {
    super(props);
    const _user = localStore.get("_user");
    this.state = {
      currentPost: null,
      editorType: [
        { type: "normal", label: "Bài viết thường", value: "normal" },
        { type: "special", label: "Bài đặc biệt", value: "special" },
        { type: "mini", label: "Bài viết mini", value: "mini" },
        ...(_user.can_create_video_post
          ? [{ type: "video", label: "Bài viết video", value: "video" }]
          : []),
        ...(_user.can_create_podcast_post
          ? [{ type: "podcast", label: "Podcast", value: "podcast" }]
          : []),
        ...(_user.can_create_short_post
          ? [{ type: "short", label: "Short", value: "short" }]
          : []),
      ],
      editorTypeSelected: {
        type: "normal",
        label: "Bài viết thường",
        value: "normal",
      },
    };
  }

  UNSAFE_componentWillMount() {
    const {
      post: { currentPost },
    } = this.props;
    let { editorType, editorTypeSelected } = this.state;

    if (currentPost.editor_type) {
      editorTypeSelected = _.find(editorType, (type) => {
        return type.type == currentPost.editor_type;
      });
    } else {
      currentPost.editor_type = "normal";
      this.props.setCurrentPost(currentPost);
    }
    this.setState({
      currentPost,
      editorTypeSelected,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      post: nextPost,
    } = nextProps;
    let { editorType, editorTypeSelected } = this.state;
    const { currentPost } = nextPost;
    if (currentPost.editor_type) {
      editorTypeSelected = _.find(editorType, (type) => {
        return type.type == currentPost.editor_type;
      });
      this.setState({editorTypeSelected});
    } else {
      currentPost.editor_type = "normal";
      this.props.setCurrentPost(currentPost);
    }
  }

  getValueEditorType = (value) => {
    this.confirmAction(value);
  };

  confirmAction(value) {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes"),
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn sắp chuyển qua layout soạn bài khác.</h1>
          <div className="box">
            <div className="bg-d9534f" onClick={onClose}>
              Không, cần xem lại
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.updateEditorType(value);
                onClose();
              }}
            >
              Có, tiếp tục
            </div>
          </div>
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => {},
      onClickOutside: () => {},
      onKeypressEscape: () => {},
    };

    confirmAlert(options);
  }

  updateEditorType = (value) => {
    let { editorType, editorTypeSelected } = this.state;
    if (value) {
      editorTypeSelected = _.find(editorType, (type) => {
        return type.type == value.value;
      });
      const {
        post: { currentPost },
      } = this.props;
      currentPost.editor_type = editorTypeSelected.value;
      // if(currentPost.editor_type == 'mini' || currentPost.editor_type == 'special'){
      //   this.setDefaultTag(currentPost.editor_type);
      // }
      // else{
      //   this.removeDefaultTag();
      // }
      this.props.setCurrentPost(currentPost);
      this.props.onSelectEditorType(editorTypeSelected, currentPost);
      this.setState({ editorTypeSelected });
    }
  };
  render() {
    const currentPost = this.props.content;
    let { layoutName, checkClass } = this.props;
    return (
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 " + checkClass}>
            <h4 className="card-title">Loại bài viết</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}
        <div className="card-body col-12">
          {currentPost &&
            currentPost.posttype &&
            currentPost.posttype.type_code !== "ready" && (
              <div className="col-xl col-lg-6 col-12 col-sm-4 mb-3 align-self-center">
                <Select
                  defaultValue={this.state.editorTypeSelected}
                  value={this.state.editorTypeSelected}
                  options={this.state.editorType}
                  onChange={this.getValueEditorType}
                  placeholder="Chọn loại bài viết"
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}
export default connect(
  (store) => {
    return {
      post: store.post,
      config: store.config,
    };
  },
  (dispatch) => {
    return {
      setCurrentPost: (value) => {
        dispatch(postActions.setCurrentPost(value));
      },
    };
  }
)(EditorTypeTab);
